import { render } from "./DownArrow.vue?vue&type=template&id=6e2a1107&scoped=true"
import script from "./DownArrow.vue?vue&type=script&lang=js"
export * from "./DownArrow.vue?vue&type=script&lang=js"

import "./DownArrow.vue?vue&type=style&index=0&id=6e2a1107&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\abelh\\.projects\\koko_v1\\koko_v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2a1107"]])

export default __exports__